import { useQuery } from '@tanstack/react-query'
import { checkDuplicateOverrideRule } from '../../../api/plan-benefit-override-rules-api'
import type { CheckDuplicateOverrideRuleQueryDto } from '../../../api/dto/plan-benefit-override-rules.dto'

export const OVERRIDE_RULE_CHECK_DUPLICATE_QUERY_KEY =
  'overrideRuleCheckDuplicate'

function isCompleteQuery(
  query: Partial<CheckDuplicateOverrideRuleQueryDto>
): query is CheckDuplicateOverrideRuleQueryDto {
  return (
    query.hiosPlanId !== undefined &&
    query.year !== undefined &&
    query.benefitName !== undefined
  )
}

export function useCheckDuplicateOverrideRule(
  query: Partial<CheckDuplicateOverrideRuleQueryDto>,
  enabled: boolean
) {
  return useQuery({
    queryKey: [OVERRIDE_RULE_CHECK_DUPLICATE_QUERY_KEY, query],
    queryFn: () => {
      if (!isCompleteQuery(query)) {
        throw new Error('useCheckDuplicateOverrideRule: query is incomplete')
      }
      return checkDuplicateOverrideRule(query)
    },
    enabled,
    staleTime: 0,
  })
}
